import { render, staticRenderFns } from "./AddTransformWizard.vue?vue&type=template&id=575d7f6a&"
import script from "./AddTransformWizard.vue?vue&type=script&lang=js&"
export * from "./AddTransformWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports